import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Button, Spinner, Alert, Row, Col } from 'react-bootstrap';
import api from '../api/axios';

const CaseStudyList = () => {
  const [caseStudies, setCaseStudies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCaseStudies = async () => {
      try {
        const res = await api.get('/case-studies.php');
        setCaseStudies(res.data);
      } catch (err) {
        console.error(err);
        alert('Failed to load case studies');
      } finally {
        setLoading(false);
      }
    };
    fetchCaseStudies();
  }, []);

  if (loading) return <Container className="mt-5 text-center"><Spinner animation="border" /></Container>;

  return (
    <Container className="mt-4">
      <h2>Case Studies</h2>
      <Button variant="outline-primary" className="mb-3" onClick={() => navigate('/dashboard')}>
        Back to Dashboard
      </Button>
      {caseStudies.length === 0 && <Alert variant="info">No case studies available.</Alert>}
      <Row>
        {caseStudies.map(cs => (
          <Col md={4} key={cs.id} className="mb-3">
            <Card>
              <Card.Body>
                <Card.Title>{cs.title}</Card.Title>
                <Card.Text>{cs.description || 'No description'}</Card.Text>
                <Button variant="primary" onClick={() => navigate(`/case-study/${cs.id}`)}>
                  Start
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default CaseStudyList;